var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformanceUsers(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.5C9.11866 12.5 10.9375 10.6812 10.9375 8.4375C10.9375 6.19384 9.11866 4.375 6.875 4.375C4.63134 4.375 2.8125 6.19384 2.8125 8.4375C2.8125 10.6812 4.63134 12.5 6.875 12.5Z",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1445 4.52628C12.7033 4.36885 13.2893 4.33299 13.8631 4.4211C14.4369 4.50922 14.9851 4.71928 15.4709 5.03713C15.9567 5.35497 16.3687 5.77323 16.6792 6.26372C16.9898 6.75421 17.1916 7.30555 17.2711 7.8806C17.3506 8.45565 17.3059 9.04106 17.1401 9.5974C16.9743 10.1537 16.6912 10.6681 16.3099 11.1058C15.9286 11.5435 15.4579 11.8944 14.9295 12.1349C14.4011 12.3754 13.8274 12.4999 13.2468 12.5",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.4216C1.88448 14.5191 2.72679 13.7825 3.70582 13.274C4.68485 12.7655 5.77186 12.5 6.87506 12.5C7.97827 12.5 9.0653 12.7654 10.0444 13.2738C11.0234 13.7822 11.8658 14.5187 12.5004 15.4212",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 12.5C14.3455 12.4992 15.4328 12.7643 16.4119 13.2728C17.3911 13.7813 18.2333 14.5182 18.8672 15.4212",
    stroke: "#5D54D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceUsers);
export default __webpack_public_path__ + "static/media/performance-users.11beef02e65a13d6152eac949a3f7ba4.svg";
export { ForwardRef as ReactComponent };